const removeValueFromEntries = (entries) => (Array.isArray(entries)
  ? entries.map((entry) => (
    entry && typeof entry === 'object'
      ? Object.fromEntries(Object.entries(entry).filter(([key]) => key !== 'value'))
      : entry
  ))
  : entries);

const removeValueFromState = (state) => Object.fromEntries(
  Object.entries(state ?? {}).map(([key, entries]) => [
    key,
    key === 'enableFilterImage' ? removeValueFromEntries(entries) : entries,
  ]),
);

const removeSelectedImage = (selected) => Object.fromEntries(
  Object.entries(selected ?? {}).filter(([key]) => key !== 'enableFilterImage'),
);

/**
 * Remove enableFilterImage from each SKU's selected state and remove the
 * `value` property from enableFilterImage entries in enabled/disabled states.
 * Returns a new EMS data object without mutating the input.
 * @param {object} emsData - EMS data to clean.
 * @returns {object} A copied EMS data object with the matching values removed.
 */
export const removeEnableFilterImageValues = (emsData = {}) => {
  const skuVariantMatrix = emsData?.skuVariantMatrix;
  if (!skuVariantMatrix || typeof skuVariantMatrix !== 'object') return { ...emsData };

  return {
    ...emsData,
    skuVariantMatrix: Object.fromEntries(
      Object.entries(skuVariantMatrix).map(([sku, skuData]) => [
        sku,
        skuData && typeof skuData === 'object'
          ? {
            ...skuData,
            ...(skuData?.selected && typeof skuData.selected === 'object'
              ? { selected: removeSelectedImage(skuData.selected) }
              : {}),
            ...(skuData?.enabled && typeof skuData.enabled === 'object'
              ? { enabled: removeValueFromState(skuData.enabled) }
              : {}),
            ...(skuData?.disabled && typeof skuData.disabled === 'object'
              ? { disabled: removeValueFromState(skuData.disabled) }
              : {}),
          }
          : skuData,
      ]),
    ),
  };
};
